import { render, staticRenderFns } from "./Designers.vue?vue&type=template&id=ca040c2c&scoped=true"
import script from "./Designers.vue?vue&type=script&lang=js"
export * from "./Designers.vue?vue&type=script&lang=js"
import style0 from "./Designers.vue?vue&type=style&index=0&id=ca040c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca040c2c",
  null
  
)

export default component.exports